import { render } from "./ConfigurationAlarm.vue?vue&type=template&id=84637342&scoped=true"
import script from "./ConfigurationAlarm.vue?vue&type=script&lang=js"
export * from "./ConfigurationAlarm.vue?vue&type=script&lang=js"

import "./ConfigurationAlarm.vue?vue&type=style&index=0&id=84637342&lang=less&scoped=true"
import "./ConfigurationAlarm.vue?vue&type=style&index=1&id=84637342&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84637342"]])

export default __exports__